<template>
    <card class="m-0 p-0">
        <form v-if="user" v-loading.lock="saving"
              :element-loading-text="$t('Saving...')">
            <div class="card-body row pt-0">
                <div class="col-12">
                    <legend>{{$t('Login credentials')}}</legend>
                    <div class="row">
                        <div class="col-md-6">
                            <fg-input type="text"
                                      :label="$t('Login name')"
                                      required
                                      disabled
                                      name="username"
                                      :placeholder="$t('Login name')"
                                      v-model="user.username">
                            </fg-input>
                        </div>
                    </div>
                </div>
                <div class="col-12"><hr></div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-3">
                            <fg-input type="text"
                                      :label="$t('First Name')"
                                      :placeholder="$t('First Name')"
                                      v-model="user.firstName">
                            </fg-input>
                        </div>
                        <div class="col-md-3">
                            <fg-input type="text"
                                      :label="$t('Last Name')"
                                      :placeholder="$t('Last Name')"
                                      v-model="user.lastName">
                            </fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input type="email"
                                      required
                                      autocomplete="off"
                                      v-validate="validations.email"
                                      :error="errors.first('email')"
                                      :label="$t('Email')"
                                      name="email"
                                      :placeholder="$t('Email')"
                                      v-model="user.email">
                            </fg-input>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <p-button round native-type="submit" type="primary" class="btn btn-fill btn-wd" :disabled="saving"
                          @click.prevent="save">
                    {{ $t('Save') }}
                </p-button>
            </div>
            <div class="clearfix"></div>
        </form>
    </card>
</template>

<script>
  export default {
    data () {
      return {
        userData: {},
        validations: {
          username: {
            required: true
          },
          email: {
            required: true,
            email: true
          }
        }
      }
    },
    components: {},
    methods: {
      save: async function () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        try {
          const { email, firstName, lastName } = this.user
          const data = { email, firstName, lastName }

          await this.$auth.updateUser(data)

          this.$notify({ type: 'success', message: 'Successfully saved' })
        } catch (e) {
          this.$notify({ type: 'danger', title: 'Error', message: e.message })
        }
      }
    },
    async mounted () {
      this.$sidebar.showSidebar = false;
      // refresh current user
      await this.$auth.getUser()

      if (this.$auth.user) {
        // create work copy
        const { username, email, firstName, lastName, password } = this.$auth.user
        this.userData = { username, email, firstName, lastName, password }
      }
    },
    computed: {
      user: function () {
        return this.userData
      },
      saving: function () {
        return this.$auth.updating
      }
    }
  }

</script>

